// @ts-check

import { useZeroContext } from '~/components/ZeroContext';
import TaskDetailModal from '~/components/Tasks/TaskDetailModal';
import { useTaskDataGridContext } from '~/components/Tasks/TaskDataGrid/TaskDataGrid.context';
import { EventNames } from '~/components/Tasks/TaskDataGrid/TaskDataGrid.utils';
import ConfirmModal from '~/components/Shared/ConfirmModal';
import { tasksApi } from '~/api/zero-api';
import NotificationAlert from '~/other/NotificationAlert';
import { getErrorMessageFromResponse } from '~/other/Helper';
import DeleteTaskConfirmationModal from '~/components/Tasks/DeleteTaskModal';

export function TaskDataGridModals() {
    const { events } = useZeroContext();
    const { activeModal, setActiveModal } = useTaskDataGridContext();

    if (!activeModal) {
        return null;
    }

    const {key, task} = activeModal;
    const onClose = () => setActiveModal(null);
    const onMutation = () => events.emit(EventNames.REFRESH_DATA);

    const props = {task, onClose, onMutation};

    switch (key) {
        case "detail":
            return <TaskDetailModal {...props}  />;
        case "delete":
            return <DeleteTaskConfirmationModal {...props} />
        default:
            console.error(`Unknown task table modal '${key}'`);
    }

    return null;
}
